<template>
  <!--  viewBox="0 0 5 8" fill="none" -->
  <path stroke="currentColor" d="M1 1L4 4L1 7" stroke-linecap="round" stroke-linejoin="round"/>
</template>